import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/views/MyConcern.vue'

Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login",
      meta: {
        title: "登录"
        // 添加该字段，表示进入这个路由是需要登录的
      }
    },

    {
      path: "",
      component: resolve => require(["../views/components/home.vue"], resolve),
      children: [
        {
          path: "/indexs",
          name: "首页",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/components/indexs.vue"], resolve)
        },
        {
          path: "/index",
          name: "首页",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/components/index.vue"], resolve)
        },
        {
          path: "/certificate/:id",
          name: "证书",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/certificate/index.vue"], resolve)
        },
        {
          path: "/course/:id",
          name: "课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/course/index.vue"], resolve)
        },
        {
          path: "/ranking",
          name: "排行榜",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/ranking/index.vue"], resolve)
        },

        {
          path: "/columnmore/:id",
          name: "课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/components/columnmore.vue"], resolve)
        },
        {
          path: "/search",
          name: "课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/components/search.vue"], resolve)
        },
        {
          path: "/fault",
          name: "考试",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/index.vue"], resolve)
        },
        {
          path: "/my",
          name: "我的",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/index.vue"], resolve)
        },
        {
          path: "/main/:id",
          name: "证书",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/certificate/main.vue"], resolve)
        },
        {
          path: "/collection",
          name: "我的收藏",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/collection.vue"], resolve)
        },
        {
          path: "/collect/:courseid/:charpid/:semgtid",
          name: "收藏题目",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/collect.vue"], resolve)
        },
        {
          path: "/visit",
          name: "访客管理",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/visit.vue"], resolve)
        },
        {
          path: "/sao",
          name: "扫一扫",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/sao.vue"], resolve)
        },
        {
          path: "/signmeeting/:id",
          name: "签到",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/signmeeting.vue"], resolve)
        },
    
        {
          path: "/search",
          name: "搜索",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/components/search.vue"], resolve)
        },
        {
          path: "/changepwd",
          name: "修改密码",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/changepwd.vue"], resolve)
        },
        {
          path: "/notice",
          name: "我的消息",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/notice.vue"], resolve)
        },
        {
          path: "/mycertificate",
          name: "我的课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/mycourse.vue"], resolve)
        },
        {
          path: "/ranking",
          name: "排行榜",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/ranking/index.vue"], resolve)
        },
        {
          path: "/historyexam",
          name: "我的考试卷",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/historyexam.vue"], resolve)
        },
        {
          path: "/examdetail/:id",
          name: "考试详情",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/examdetail.vue"], resolve)
        },
        {
          path: "/questionnaireDetail/:id/:type",
          name: "课程介绍",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/my/questionnaireDetail.vue"], resolve)
        },
        {
          path: "/more/:typename",
          name: "搜索课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/components/more.vue"], resolve)
        },
        {
          path: "/mores/:id/:name",
          name: "搜索课程",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/components/mores.vue"], resolve)
        },
        {
          path: "/questionbankexercise",
          name: "题库练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/fault/questionbankexercisecopy.vue"], resolve)
        },
        {
          path: "/ercisescopy/:courseid/:charpid/:semgtid",
          name: "题库练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/ercisescopy.vue"], resolve)
        },
        {
          path:
            "/questionbankexercises/:id/:segmentId/:danxuan/:duoxuan/:panduan/:isFirst",
          name: "题库练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/fault/questionbankexercises.vue"], resolve)
        },
        {
          path: "/Sequentialexercise/:id/:segmentId/:courseid",
          name: "顺序练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/fault/Sequentialexercise.vue"], resolve)
        },
        {
          path: "/imitate/:id/:segmentId/:courseid/:isFirst",
          name: "模拟练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/imitate.vue"], resolve)
        },
        {
          path: "/wrongquestion/:courseid/:charpid/:semgtid",
          name: "错题练习",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/fault/wrongquestion.vue"], resolve)
        },
        {
          path: "/error/:courseid/:charpid/:semgtid",
          name: "纠错",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/error.vue"], resolve)
        },
        {
          path: "/list/:id",
          name: "课程介绍",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/list/index.vue"], resolve)
        },
        {
          path: "/knowledgeInfodetail/:id",
          name: "课程介绍",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve =>
            require(["../views/certificate/knowledgeInfodetail.vue"], resolve)
        },
        {
          path: "/video/:id/:sugeid",
          name: "视频",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/video/index.vue"], resolve)
        },
        {
          path: "/dulivideo/:id",
          name: "视频",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/video/dulivideo.vue"], resolve)
        },
        {
          path: "/mytask",
          name: "我的作业",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/mytask.vue"], resolve)
        },
        {
          path: "/taskchoose/:id",
          name: "我的作业",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/taskchoose.vue"], resolve)
        },
        {
          path: "/questionnaire",
          name: "问卷调查",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/questionnaire.vue"], resolve)
        },
        {
          path: "/mynote",
          name: "我的笔记",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/mynote.vue"], resolve)
        },
        {
          path: "/mydata",
          name: "我的资料",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/mydata.vue"], resolve)
        },
        {
          path: "/examination/:id/:indexs",
          name: "考试",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/examination.vue"], resolve)
        },
        {
          path: "/ceshi/:id",
          name: "测试",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/my/ceshi.vue"], resolve)
        },
        {
          path: "/AnswerSheet/:id",
          name: "答题卡",
          meta: {
            requireAuth: true
            // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(["../views/fault/AnswerSheet.vue"], resolve)
        }
      ]
    },
    // {
    //   path: "/stxq/:id", //题库查看
    //   meta: {
    //     requireAuth: true
    //     // 添加该字段，表示进入这个路由是需要登录的
    //   },
    //   component: resolve =>
    //     require([
    //       "../views/components/Questionbank/watchquestionnbank.vue"
    //     ], resolve)
    // },
    // {
    //   path: "/exerciseexam/:id", //证书练习
    //   meta: {
    //     requireAuth: true
    //     // 添加该字段，表示进入这个路由是需要登录的
    //   },
    //   component: resolve =>
    //     require(["../views/components/Questionbank/exerciseexam.vue"], resolve)
    // },
    {
      path: "/login1",

      component: resolve => require(["../views/components/login.vue"], resolve)
    },
    {
      path: "/login2",

      component: resolve => require(["../views/components/login2.vue"], resolve)
    },
    {
      path: "/LoginOutSucc",

      component: resolve =>
        require(["../views/components/LoginOut.vue"], resolve)
    },
    // 企业微信登陆页面
    {
      path: "/login",

      component: resolve =>
        require(["../views/components/login_wx.vue"], resolve)
    },
    {
      path: "/error",

      component: resolve => require(["../views/components/error.vue"], resolve)
    },
    

    // {
    //   path: "/courseVideo/:id", //视频页面
    //   meta: {
    //     requireAuth: true
    //     // 添加该字段，表示进入这个路由是需要登录的
    //   },
    //   component: resolve =>
    //     require(["../views/components/courseVideo.vue"], resolve)
    // },

    // {
    //   path: "/register",
    //   component: resolve =>
    //     require(["../views/components/register.vue"], resolve)
    // }
  ]
});
router.beforeEach(function(to, from, next) {
  // 获取当前跳转的路径
  var hrefs = window.location.href;
  let hrefIdx = hrefs.indexOf("loginName=");
  if (hrefIdx > -1) {
    location.href = "/";
    next();
  } else {
    // //console.log(to);
    // //console.log(to.meta.requireAuth);
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    if (to.matched.some(record => record.meta.requireAuth)) {
      // 判断该路由是否需要登录权限

      if (localStorage.token) {
        // 判断当前的token是否存在 ； 登录存入的token
        next();
      } else {
        //设置成功登陆后需要跳转的地址
        localStorage.setItem("redirectUrl", window.location.href);
        next({
          path: "/",
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    } else {
      // //console.log(1);
      next();
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js